import React from 'react';
import {
  Tooltip, TooltipTrigger, TooltipContent, TooltipProvider,
} from '../ui/tooltip';
import { Info } from 'lucide-react';

/**
 * Displays the customer-facing part number with an internal-only hover tooltip
 * showing the IPN. The IPN icon is hidden when:
 *   - there is no customer P/N (we already show IPN as the main value), or
 *   - customer P/N === internal P/N (redundant).
 *
 * Strictly an on-screen helper — never used in PDF print views, so the
 * customer-facing document remains uncluttered.
 */
export function PartNoCell({ customerPartNo, internalPartNo, className = '' }) {
  const display = customerPartNo || internalPartNo || '-';
  const showTooltip = !!customerPartNo && !!internalPartNo && customerPartNo !== internalPartNo;

  if (!showTooltip) {
    return <span className={`font-mono ${className}`}>{display}</span>;
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`font-mono inline-flex items-center gap-1 cursor-help ${className}`}
            data-testid="part-no-cell"
          >
            {display}
            <Info className="h-3 w-3 text-slate-400" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="bg-slate-900 text-white">
          <span className="text-[11px]">IPN: <span className="font-mono font-semibold">{internalPartNo}</span></span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
